/**
 * Extension Page - Chrome Extension landing page
 */

import { useState } from 'react';
import './Extension.css';

// Set to actual Chrome Web Store URL once published
const CHROME_STORE_URL: string | null = null;
const MANUAL_DOWNLOAD_URL = '/downloads/refinevoice-extension.zip';

export function Extension() {
  const [showInstructions, setShowInstructions] = useState(false);

  return (
    <div className="extension-page">
      <div className="extension-card">
        <div className="extension-hero">
          <div className="extension-icon">
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              aria-hidden="true"
            >
              <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
              <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
              <line x1="12" y1="19" x2="12" y2="22" />
            </svg>
          </div>
          <h1>RefineVoice Chrome Extension</h1>
          <p className="extension-tagline">Voice-to-text on any website</p>
        </div>

        <div className="extension-features">
          <div className="feature">
            <span className="feature-icon">🎤</span>
            <div>
              <h3>Speak Anywhere</h3>
              <p>Dictate text into any input field on the web</p>
            </div>
          </div>
          <div className="feature">
            <span className="feature-icon">✨</span>
            <div>
              <h3>AI Refinement</h3>
              <p>Clean up and improve your transcriptions</p>
            </div>
          </div>
          <div className="feature">
            <span className="feature-icon">⚡</span>
            <div>
              <h3>One-Click Activation</h3>
              <p>Floating button appears on text inputs</p>
            </div>
          </div>
        </div>

        <div className="extension-cta">
          {CHROME_STORE_URL ? (
            <a
              href={CHROME_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="extension-btn extension-btn-primary"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M12 0C8.21 0 4.831 1.757 2.632 4.501l3.953 6.848A5.454 5.454 0 0 1 12 6.545h10.691A12 12 0 0 0 12 0zM1.931 5.47A11.943 11.943 0 0 0 0 12c0 6.012 4.42 10.991 10.189 11.864l3.953-6.847a5.45 5.45 0 0 1-6.865-2.29L1.931 5.47zm13.123 2.528a5.449 5.449 0 0 1 .696 8.692l-3.953 6.847c.753.063 1.504.063 2.255 0A12 12 0 0 0 24 12c0-.669-.054-1.325-.16-1.965H15.054a5.452 5.452 0 0 1 0 4.218l5.346-.063A12.025 12.025 0 0 0 24 12c0-1.525-.285-2.982-.802-4.325H15.054z" />
              </svg>
              Add to Chrome
            </a>
          ) : (
            <a href={MANUAL_DOWNLOAD_URL} download className="extension-btn extension-btn-primary">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                aria-hidden="true"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Download Extension
            </a>
          )}
          <p className="extension-note">Free to use with your RefineVoice account</p>
        </div>

        {!CHROME_STORE_URL && (
          <div className="extension-manual-install">
            <button
              type="button"
              className="instructions-toggle"
              onClick={() => setShowInstructions(!showInstructions)}
            >
              {showInstructions ? 'Hide' : 'Show'} installation instructions
            </button>

            {showInstructions && (
              <ol className="install-steps">
                <li>Download the extension zip file above</li>
                <li>Unzip the file to a folder on your computer</li>
                <li>
                  Open Chrome and go to <code>chrome://extensions</code>
                </li>
                <li>Enable "Developer mode" (top right toggle)</li>
                <li>Click "Load unpacked" and select the unzipped folder</li>
                <li>The RefineVoice icon will appear in your toolbar</li>
              </ol>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
